import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { usePrefetchTopics } from '../api/topics/topicsQuery';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { RootState } from '../app/store';
import { populateAllConnectionsProfiles } from '../features/connections/model/slice/asyncReducers/connections';
import { populateAllConversations } from '../features/messaging/model/asyncReducers/messaging';
import { selectMyConnectionsFeatureFlag } from '../features/user/selectors';
import { usePollForMessages } from './usePollForMessages';

export const usePrefetchData = () => {
    const dispatch = useAppDispatch();
    const isConnections = useSelector(selectMyConnectionsFeatureFlag);
    const isAuthenticated = useAppSelector((state: RootState) => state.authentication.isAuthenticated);

    /** slice */
    useEffect(() => {
        if (isConnections && isAuthenticated) {
            dispatch(populateAllConnectionsProfiles());
            dispatch(populateAllConversations());
        }
    }, [dispatch, isConnections, isAuthenticated]);

    // this is feature-flagged internally
    usePollForMessages();

    /** query */
    usePrefetchTopics();
};
